import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import type TrackerImportStore from "./TrackerImportStore";

const storeOf = (rootStore: RootStore) =>
  (rootStore as unknown as { trackerImportViewStore?: TrackerImportStore }).trackerImportViewStore;

/**
 * Admin → Import trackers: Blake's accounts-receivable, contracts and
 * onboarding exports into HQ (#3075 / #2663) — a dry run, the column and value
 * mapping, then one import. Administrators only; the API refuses anyone else.
 */
const trackerImportRoute: RouteType = {
  name: "TrackerImport",
  title: "Import trackers",
  path: "/admin/tracker-import",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Import trackers",
      enableRefreshButton: true,
      component: () => import("./TrackerImport.Header"),
    },
    body: {
      component: () => import("./TrackerImport.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["import", "blake", "receivables import", "contracts import", "onboarding import", "csv", "xlsx"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
  onEnter: ({ rootStore }) => {
    void storeOf(rootStore)?.initialize();
  },
  onExit: ({ rootStore }) => {
    storeOf(rootStore)?.reset();
  },
};

export default trackerImportRoute;
